/**
 * @description 支付方式用
*/
export enum PaymentMethod {
  /** 信用卡支付 */
  CreditCard = '1',
  /** 活期存款帳戶 */
  BankAccount = '2',
  /** 繳費條碼 */
  BarCode = '3'
}
